<template><div><h1 id="spende-erfassen" tabindex="-1"><a class="header-anchor" href="#spende-erfassen"><span>Spende erfassen</span></a></h1>
<p>Spende manuell erfassen — Spende in manuellen Buchungen erfassen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Beim Erfassen einer Spende werden gleichzeitig zwei Buchungen erfasst. Eine Buchung als Zahlung auf das Debitorenkonto und gleichzeitig die Spende aus dem Debitorenkonto, so dass der Saldo des Debitorenkontos unverändert bleibt. Beim Erfassen der Spendenbuchung wird ein Ereignis eingegeben das auf den Ereignistyp &quot;RSS&quot; und die Gültigkeit validiert. Als Ereignis wird automatisch der Wert des Systemparameters <RouteLink to="/referenz/refs/ft.refdata.sysparam.html#ft.x-par.dfez">dfez</RouteLink> vorgeschlagen. Das Ertragskonto wird vom entsprechenden Ereigniskopf übernommen. Bei der Zahlungsbuchung muss der Betrag, das Datum und das Konto eingegeben werden.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Neue Spende (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Spende gebucht wird</dd>
<dt>Ereignis</dt>
<dd>Auswahl eines <a class="link" href="ft.refdata.ereigkopf.html" title="Ereignisse">Ereignisses</a> und einer <a class="link" href="ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition</a></dd>
<dt>Betrag</dt>
<dd>Spendenbetrag eintragen</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
<dt>Mandant</dt>
<dd>Der <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> wird nur eingetragen, wenn er auf Grund der Konteneingabe nicht eindeutig feststellbar ist</dd>
<dt>Konto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Zahlungsnummer</dt>
<dd>Frei definierbare Zahlungsnummer</dd>
</dl>
<h3 id="mogliche-situationen-beim-erfassen-einer-spende" tabindex="-1"><a class="header-anchor" href="#mogliche-situationen-beim-erfassen-einer-spende"><span>Mögliche Situationen beim Erfassen einer Spende</span></a></h3>
<table>
<thead>
<tr>
<th>Währung der Spende</th>
<th>Auswirkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Spende in Landeswährung</td>
<td>Bei Eingabe der Zahlung muss die Währung des Habenkontos die Landeswährung sein. Der Landeswährungsbetrag muss grösser Null und der Fremdbetrag muss gleich Null sein. Falls es sich um eine Spende mit MWST handelt, wird der MWST-Anteil der Spende in den Einzelbuchungen separat als eine Spende auf die entsprechenden MWST-Konti verbucht. Die Spende wird in Landeswährung verbucht.</td>
</tr>
<tr>
<td>Spende in Fremdwährung</td>
<td>Bei Eingabe der Zahlung muss die Währung des Habenkontos, sowie die Währung des Fremdbetrages der Währung der Spende entsprechen. Der Fremdwährungsbetrag muss grösser Null sein. Der Betrag in der Landeswährung wird automatisch aus dem Fremdwährungsbetrag mit dem Kurs des Valutadatums umgerechnet und die Spende wird in der Landeswährung verbucht. Falls es sich um eine Spende mit MWST handelt, wird der MWST-Anteil der Spende (nach der Umrechnung in die Landeswährung) in den Einzelbuchungen separat als eine Spende auf die entsprechenden MWST-Konti verbucht.</td>
</tr>
</tbody>
</table>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


